import { render, staticRenderFns } from "./sample-order-form-component.vue?vue&type=template&id=f32a9eb2&scoped=true"
import script from "./sample-order-form-component.vue?vue&type=script&lang=js"
export * from "./sample-order-form-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f32a9eb2",
  null
  
)

export default component.exports